import React from 'react';
import {
  getDatasetOverviewItems,
  OVERVIEW_CHIP_CLASS,
  OVERVIEW_CHIP_LABEL_CLASS,
  OVERVIEW_CHIP_VALUE_CLASS,
} from './datasetOverview';

const DatasetOverviewChips = ({ dataset }) => {
  const items = getDatasetOverviewItems(dataset);

  if (items.length === 0) return null;

  return (
    <>
      {items.map((item) => (
        <div key={item.label} className={OVERVIEW_CHIP_CLASS}>
          <span className={OVERVIEW_CHIP_LABEL_CLASS}>{item.label}</span>
          <span className={OVERVIEW_CHIP_VALUE_CLASS}>{item.value}</span>
        </div>
      ))}
    </>
  );
};

export default DatasetOverviewChips;
